import { useState, useEffect, useCallback } from 'react';
import { FiMenu } from 'react-icons/fi';
import OSidebar from './OSidebar';

const COLLAPSE_KEY = 'os-sidebar-collapsed';

export default function AppShell({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Compact rail. Desktop only — on mobile the sidebar is a drawer that is
  // either open (full width) or off-screen, so collapsing it means nothing.
  // Persisted because it is a standing preference, not a per-visit choice.
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem(COLLAPSE_KEY) === '1'; } catch { return false; }
  });

  const toggleCollapsed = useCallback(() => {
    setCollapsed((c) => {
      const next = !c;
      try { localStorage.setItem(COLLAPSE_KEY, next ? '1' : '0'); } catch { /* private mode */ }
      return next;
    });
  }, []);

  useEffect(() => {
    const check = () => setSidebarOpen(window.innerWidth >= 1024);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return (
    <div className="flex h-shell overflow-hidden inset-shell" style={{ background: 'var(--os-page-bg)' }}>
      <OSidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={collapsed}
        onToggleCollapse={toggleCollapsed}
      />
      <main className="flex-1 overflow-y-auto min-w-0 inset-bottom">
        {/* Mobile top bar with hamburger */}
        <div
          className="lg:hidden flex items-center px-4 py-3 shrink-0 sticky top-0 z-20 inset-top"
          style={{ background: 'var(--os-page-bg)', borderBottom: '1px solid var(--os-border)' }}
        >
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-2 rounded-lg mr-3"
            style={{ background: 'var(--os-border-subtle)', color: 'var(--os-ink)' }}
          >
            <FiMenu className="w-5 h-5" />
          </button>
          <span
            className="font-display text-[1.1667rem] font-semibold"
            style={{ color: 'var(--os-gold-500)' }}
          >
            Gumma's Glam House
          </span>
        </div>
        <div className="animate-fade-in">{children}</div>
      </main>
    </div>
  );
}
